<h2 mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <div class="upload-layer-container" [formGroup]="newLayerForm">
    <mat-label class="p-2">Enter a name for the Vector Tile Layer.</mat-label>
    <mat-form-field class="form-slim w-100 mt-1">
      <input matInput placeholder="New Layer Name" formControlName="newVectorTileLayerName" id="newVectorTileLayerName" type="text" maxlength="18" />
    </mat-form-field>
    <div class="d-flex align-items-center g-1 mt-1">
      <span>Opacity:</span>
      <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
        <input matSliderThumb formControlName="newVectorTileLayerOpacity">
      </mat-slider>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button matButton="filled" color="primary"  id="btnAdd" [mat-dialog-close]="true" (click)="addVectorTileLayers()">Add</button>
</mat-dialog-actions>
